export * from "./icons/index.js"
import { FanIcon } from "./icons/index.js"

// 全局注册    
export function install(app) {
  if (FanIcon.install) {
    app.use(FanIcon);
  } else if (FanIcon.name) {
    app.component(FanIcon.name, FanIcon);
  }
}